
import ErrorPage from "../error-page";
import PasswordSuccess from '../components/PasswordSuccess';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import UpdatePassword from '../components/UpdatePasswordScreen';

const router = createBrowserRouter([
  {
    path: "/",
    element: <UpdatePassword />,
    errorElement: <ErrorPage />
  },
  {
    path:"/success",
    element: <PasswordSuccess />,
    errorElement: <ErrorPage />
  },
  {
    path: "/error",
    element: <ErrorPage />
  }
]);

export function Provider({ children }) {
    return (
      <RouterProvider router={router}>
        {children}
      </RouterProvider>
    )
}

